

export const getTipSelectors = (state) => {
    const { isFetching,selectedTip,itemsById } = state.tips || {};
    return { isFetching,selectedTip,itemsById };
};